module.exports = __webpack_public_path__ + "img/search.d6880261.png";